export const environment = {
  production: false,
  // dev
  //url: 'http://192.168.1.159:8085/incubators/',
  // uat
  // url:'http://ec2-3-109-200-15.ap-south-1.compute.amazonaws.com/incubators/',
  // live
  url: 'https://api.tncatalyst.in/incubators/',

  register: 'register',
  login: 'login',
  incubaterList: 'incubators',
  calculateScore: 'calculateScore?incubatorId=',
  profileSave: 'incubatorProfileSave',
  profileGet: 'incubatorProfileGet',
  adminprofileGet: 'incubators/admin/profile/Get',
  removeBrouchure: 'removeProfileBrouchure',
  fundingDelete: 'incubatorFundingRemove?incubatorFundingId=',
  sponsorShipDelete: 'incubatorSponsorshipRemove?incubatorSponsorshipId=',
  searchIncubator: 'incubatorProfiles',
  excelDownload: 'exportIncubators?status=',
  preincubationexcelDownload: 'preincubation/list/download',
  eventSave: 'eventSave',
  eventList: 'eventList',
  eventGet: 'eventGet?',
  eventApproved: 'eventStatusUpdate',
  eventDelete: 'eventRemove',
  mapGet: 'incubatorsDistrictWise',
  gallerySave: 'gallerySave',
  galleryList: 'galleryList',
  galleryGet: 'galleryGet?id=',
  galleryDelete: 'galleryRemove',
  blogSave: 'blogSave',
  blogList: 'blogList',
  blogGet: 'blogGet?',
  blogDelete: 'blogRemove?blogId=',
  blogImageDelete: 'blogImageRemove?id=',
  dashboardGet: 'dashboard?',
  updateStatus: 'updateTnimmStatus',
  managementStratgeySave: 'tnimmManagementSave',
  managementStratgeyGet: 'tnimmManagementGet?incubatorId=',
  knowledgeSave: 'tnimmKnowledgeSave',
  knowledgeGet: 'tnimmKnowledgeGet?incubatorId=',
  financialSave: 'tnimmFinancialSave',
  financialGet: 'tnimmFinancialGet?incubatorId=',
  hrSave: 'tnimmHRSave',
  hrGet: 'tnimmHRGet?incubatorId=',
  phyInfSave: 'tnimmPhysicalInfrastuctureSave',
  phyInfGet: 'tnimmPhysicalInfrastuctureGet?incubatorId=',
  networkSave: 'tnimmNetworkingSave',
  networkGet: 'tnimmNetworkingGet?incubatorId=',
  socialSave: 'tnimmSocialImpactSave',
  socialGet: 'tnimmSocialImpactGet?incubatorId=',
  resultSave: 'tnimmResultSave',
  resultGet: 'tnimmResultGet?incubatorId=',
  incubateeSave: 'incubateeSave',
  incubateeList: 'incubateeList',
  incubateeGet: 'incubateeGet?',
  incubateeDownload: 'exportIncubatees?incubatorId=',
  incubatorVideoSave: 'uploadvideo',
  incubatorApprovalList: 'incubatorsAllStatus',
  incubatorApprovalSave: 'incubatorApproval',
  corporateApprovalList: 'csrproject/allstatus',
  corporateApprovalSave: 'corporate/approval',
  incubatorRemove: 'incubatorRemove?incubatorId=',
  corporteRemove: 'corporateRemove?corporateId=',
  incubatorNameList: 'incubatorsNamelist',
  incubatorGet: 'incubatorProfileDetails?',
  publishScore: 'publishScore',
  saveAll: 'saveAll',
  unsubscribe: 'unsubscribe?data=',
  startupsList: 'startupsList?',
  downloadScore: 'exportIncubatorsScore',
  submitFormList: 'incubatorConnect',
  newsletterList: 'newsletterList',
  incubnewsletterList: 'newsletter/incubator/list',
  homenewsletterList: 'home/newsletters/list',
  newsletterSave: 'newsletterSave',
  newsletterGet: 'newsletterGet?id=',
  newsletterDelete: 'newsletterRemove?id=',
  infraList: 'incubatorsFacilityList',
  incubatorProfileSave: 'incubatorProfileSave',
  incubatorProfileGet: 'incubatorProfileGet',
  incubatorProfileGet2: '',
  csrProjectSave: 'csrProjectSave',
  csrProjectGet: 'csrproject/get?',
  csrProjectDocumentDelete: 'csrproject/document/Remove?id=',
  csrprojectList: 'csrproject/list',
  newcsrprojectList: 'csrproject/corp/list',
  csrApproval: 'csrproject/approval',
  sectorList: 'sectors/list',
  corporateExcelDownload: 'exportCorporates?status=',
  csrIntrestProject: 'csrproject/apply?',
  homelist: 'home',
  forgotSave: 'forgot/password',
  changePassword: 'change/password',
  accelatorList: 'eventList',
  accelaroeGet: 'eventGet?',
  initiativeSave: 'initiatives/save',
  initiativeList: 'initiatives/list',
  initiativeGet: 'initiatives/get?',
  initiativecorpGet: 'initiatives/menu/title/list',
  initiativeDelete: 'initiatives/remove?id=',
  initiativelistGet: 'initiatives/menu/get?',
  intenteoiSave: 'preincubation/intenteoi/save',
  intenteoiGet: 'preincubation/intenteoi/get',
  preincubaterList: 'preincubation/list',
  connectWithIncubators: 'incubatorConnectList',
  preincubaterapproval: 'preincubation/status/save',
  preincubaterhistory: 'preincubation/history',
  CoeList: 'coe/list',
  coeapproval: 'coe/status/update',
};
